const GroupAccessEnum = Object.freeze({
  GROUP_DOC_VIEWER: 'group-doc-viewer',
  GROUP_DOC_DOWNLOADER: 'group-doc-downloader',
  GROUP_DOC_EDITOR: 'group-doc-editor'
});

export default GroupAccessEnum;
